export default __webpack_public_path__ + "static/media/cardIcon_profile.e1fb0882.svg";